import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip-toggle',
  templateUrl: './chip-toggle.component.html',
  styleUrls: ['./chip-toggle.component.scss'],
})
export class ChipToggleComponent {
  @Input() text?: string;
  @Input() icon?: string;
  @Input() image?: string;
  @Input() selectedImage?: string;
  @Input() dynamicChip?: boolean;
  @Input() smallChip?: boolean;
  @Input() isSelected: boolean;
  @Input() colorClass: string;

  getImageSource(): string {
    return this.isSelected && this.selectedImage ? this.selectedImage : this.image;
  }
}
